import React, { useState, useEffect } from "react";
import "./SpecialPackage.css";
import "../SilverInvestment/SilverInvestmentDetails.css";
import landvest from "../../../../../assets/landvesticon.svg";
import closemodalicon from "../../../../../assets/close-modal-icon.svg";
import { Util } from "../../../../../../../../helpers/util";
import { $api } from "../../../../../../../../helpers/$api";

const IbadanLandvest = ({ setPage }) => {
  const { currency } = Util.getCurrency();
  const [showRoiInfo, setShowRoiInfo] = useState(null);
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const packages = await $api.investment.getSpecialPackages();

        setPackages(packages);
      } catch (error) {
        // error getting packages...
      }
    })();
  }, [setPackages]);

  return (
    <div className="silvestinvestment">
      <div>
        <div className="silvestinvestment-body">
          <div className="silvestinvestment-main">
            <h5 className="silvestinvestment-h5 mb-3">Special Packages</h5>
            <p className="silvestinvestment-textbody">
              Invest in OHouseEstate and become a land-owner in 6 months
            </p>
          </div>

          {packages.map((pkg) => {
            return (
              <div className="landvest-location mt-4">
                <div className="landvest-flex">
                  <img src={landvest} alt="an iamhge" />
                  <h5 className="landvest-title">{pkg.package_name}</h5>
                </div>
                <p className="landvest-p">
                  Become a land-owner at {pkg.package_name} in{" "}
                  <span>{Math.ceil(pkg.period / 30)} months </span>by investing
                  <span>
                    {currency}
                    {Util.formatMoneyNumber(pkg.min)}
                  </span>{" "}
                  instead of{" "}
                  <span>
                    {currency}
                    {Util.formatMoneyNumber(pkg.max)}
                  </span>
                </p>
                <button
                  onClick={() => setShowRoiInfo(pkg)}
                  className="landvest-button mb-4"
                >
                  View Details
                </button>
              </div>
            );
          })}
        </div>
      </div>
      {!!showRoiInfo && (
        <div
          className={`silverinvestment__roi-info-bg ${
            !!showRoiInfo ? "show-roi-info" : ""
          }`}
        >
          <div className="silverinvestment__roi-info-content">
            <div className="profit-roi-modal">
              <div className="dryport-body">
                <div className="dryport-header">
                  <h5>{showRoiInfo.package_name}</h5>
                  <img
                    src={closemodalicon}
                    alt="close-modal"
                    className="close-icon-btn"
                    onClick={() => setShowRoiInfo(null)}
                  />
                </div>
                <div className="railway-main">
                  <div className="railway-body">
                    <div className="railway-details">
                      <p className="mini-header">Minimum Investment Rate</p>
                      <h5 className="duration-plan">
                        {currency} {Util.formatMoneyNumber(showRoiInfo.min)}
                      </h5>
                    </div>
                    <div className="railway-details">
                      <p className="mini-header">Maximum nvestment Rate</p>
                      <h5 className="duration-plan">
                        {currency} {Util.formatMoneyNumber(showRoiInfo.max)}
                      </h5>
                    </div>
                  </div>
                  {/* <div className="railway-body">
                  <div className="railway-details">
                    <p className="mini-header">Investment Rate</p>
                    <h5 className="duration-plan">N300,000</h5>
                  </div>
                  <div className="railway-details">
                    <p className="mini-header">Investment Rate</p>
                    <h5 className="duration-plan">N300,000</h5>
                  </div>
                </div> */}
                </div>
                <div className="dryport-btn">
                  <button
                    onClick={() => setShowRoiInfo(false)}
                    className="invest"
                  >
                    Invest Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default IbadanLandvest;
